import React, { Component } from "react";
import {
  Wrapper,
  CardBody,
  Title,
  Copy,
  Bold
} from "app/NativeComponents/common";

class MailFailedMessage extends Component {
  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  render() {
    if (this.props.mail_failed_info && this.props.mail_failed_info.length > 0) {
      return (
        <Wrapper style={{ marginTop: 15 }}>
          <Title style={{ marginBottom: 5 }}>Mail Failed: </Title>
          {this.props.mail_failed_info
            ? this.props.mail_failed_info.map((info, i) => {
                return (
                  <Wrapper>
                    <Copy>
                      <Bold>Reason:</Bold>{" "}
                      {this.capitalizeFirstLetter(info.short_message)}
                    </Copy>
                    <Copy style={{ marginBottom: 5 }}>
                      <Bold>Resolution:</Bold>{" "}
                      {this.capitalizeFirstLetter(info.long_message)}
                    </Copy>
                  </Wrapper>
                );
              })
            : ""}
        </Wrapper>
      );
    }
    return <Wrapper />;
  }
}

export default MailFailedMessage;
